module.exports = {
	"pt-BR": {
		"currency_symbol": "R$",
		"name": "Easy Gestor WEB",
		"nav": {
			"welcome": "Bem vindo ao Easy Gestor Web",
			"search_placeholder": "Pesquise por algo...",
			"log_out": "Sair"
		},
		"common": {
			"errors": {
				"email": {
					"email_already_exists": "Já existe usuário com este endereço de email."
				},
				"phone_number": {
					"max_length": "Certifique-se de que este campo não tenha mais que 11 caracteres."
				},
				"plan": {
					"no_plan": "Selecione um plano para ter acesso a essa ação."
				}
			},
			"informations": "Informações",
			"address": "Endereço",
			"data": {
				"yearly": "Total Anual"
			},
			"action": {
				"label": "Ação",
				"plural": "Ações",
				"add": "Novo",
				"delete": "Remover",
				"edit": "Editar",
				"all": "Todos",
				"list": "Listar",
				"save": "Salvar",
				"cancel": "Cancelar"
			},
			"delete": {
				"label": "Deletar",
				"plural": ""
			},
			"person": {
				"basic_info": "Informações Básicas",
				"name": "Nome",
				"email": "E-mail",
				"phone_number": "Telefone",
				"person_type": "Tipo",
				"password": "Senha"
			}
		},
		"pages": {
			"dashboard": {
				"top_header": {
					"search": "Faça sua pesquisa ...",
					"exit_button": "Sair"
				},
				"graphs": {
					"sales": {
						"title": "Gráfico de vendas",
						"total_sales_today": "Total de vendas hoje"
					}
				}
			},
			"sales": {
				"label": "Venda",
				"plural_label": "Vendas"
			},
			"login": {
				"welcome": "Bem vindo ao",
				"description": "O EasyGestor online é um Sistema de Gestão, voltado para micro e pequenas empresas, 100% ausente de instalação, e com um armazenamento gerenciado com tecnologia em nuvem. Para mantermos o EasyGestor, algumas soluções específicas como, emissão de NFe e NFCe, Controle de Estoque, Relatório de Vendas, etc, serão cobradas, através de uma assinatura mensal de acordo com a sua necessidade. Mas não se preocupe, nenhum pagamento será feito sem a sua autorização prévia.",
				"login_form": {
					"label": "Faça seu login",
					"erros": {
						"email_empty": "Email não pode ser vazio"
					},
					"inputs_placeholders": {
						"email": "Digite seu email",
						"password": "Digite sua senha"
					},
					"buttons_label": {
						"to_sing": "Faça seu login",
						"to_sigup": "Faça seu cadastro",
						"to_reset_password": "Esqueceu sua senha?"
					}
				}
			},
			"register": {
				"welcome": "Registre-se no",
				"register_form": {
					"label": "Criar Conta",
					"have_account": "Já tem conta?",
					"enter_your_name": "Qual o seu nome?",
					"enter_your_email": "Digite seu email",
					"enter_your_phone": "Digite seu telefone",
					"enter_your_address": "Qual o seu cep?",
					"enter_your_password": "Escolha uma senha",
					"confirm_passwd": "Confirme sua senha",
					"read_terms": "Eu li e concordo com",
					"terms": "os termos e condições de uso"
				}
			},
			"products": {
				"label": "Produtos",
				"singular": "Produto",
				"all_label": "All Products",
				"categories": {
					"label": "Categoria",
					"plural_label": "Categorias",
					"all_label": "Todas as categorias",
					"add_label": "Adicionar uma nova categoria",
					"edit_label": "Editar categoria"
				},
				"units": {
					"label": "Unidade",
					"plural_label": "Unidades",
					"all_label": "Todas as unidades",
					"add_label": "Adicionar uma nova unidade",
					"edit_label": "Editar unidade"
				},
				"stock": {
					"labels": {
						"menu_title": "Estoque"
					}
				},
				"product_stock_history": {
					"label": "Histórico"
				},
				"suppliers": {
					"label": "Fornecedor",
					"plural_label": "Fornecedors",
					"all_label": "Todas os Fornecedores",
					"add_label": "Adicionar um Fornecedor",
					"edit_label": "Editar Fornecedor"
				},
				"clients": {
					"label": "Clientes",
					"plural_label": "Clientes",
					"singular_label": "Cliente",
					"add_label": "Adicionar",
					"all_label": "Todos os Clientes",
					"edit_label": "Editar"
				}
			},
			"statistics": {
				"label": "Estatísticas"
			},
			"reports": {
				"label": "Relatórios"
			},
			"stock": {
				"labels": {
					"menu_title": "Estoque",
					"page_title": "Informações de Estoque",
					"total_in_stock": "Total em estoque",
					"negative_stock": "Estoque negativo",
					"products_in_stock": "Produtos em estoque",
					"products_with_negative": "Produtos com estoque negativo",
					"product": "Produto",
					"quant_in_stock": "Quantidade"
				}
			},
			"product_stock_history": {
				"label": "Movimentação"
			},
			"salesperson": {
				"singular_label": "Vendedor(a)",
				"plural_label": "Vendedores",
				"add_label": "Novo Vendedor"
			},
			"financial": {
				"label": "Financeiro"
			},
			"settings": {
				"list": [
					{
						"name": "Usuário"
					},
					{
						"name": "Filial"
					},
					{
						"name": "Plano e Faturas"
					}
				],
				"labels": {
					"title": "Configurações",
					"user": {
						"name": "Nome",
						"current_name": "Nome do usuário atual",
						"phone": "Telefone",
						"current_phone": "Telefone do usuário atual",
						"email": "Email",
						"current_email": "Email do usuário atual"
					},
					"branch": {
						"name": "Name",
						"current_name": "Current branch's name",
						"fancy_name": "Nome fantasia",
						"current_fancy_name": "Nome fantasia da filial atual",
						"phone": "Telefone",
						"current_phone": "Telefone da Filial atual",
						"email": "Email",
						"current_email": "Email da filial atual",
						"thank_message": "Mensagem de Agradecimento",
						"thank_message_info": "Mensagem de agradecimento ao cliente",
						"note_orientation": "Orientação de Nota",
						"note_orientation_info": "Orientação da impressão da nota",
						"paper_printing": "Impressão da Nota",
						"paper_printing_info": "Modelo do papel de impressão",
						"automatic_printing": "Impressão automatica?",
						"automatic_printing_info": "Deseja abrir o diálogo de impressão automaticamente?"
					},
					"invoice": {
						"plan": "Plano",
						"invoices": "Faturas",
						"invoice": "Fatura",
						"situation": "Situação",
						"actions": "Ações",
						"pending": "Pendente",
						"paid": "Pago"
					}
				},
				"buttons": {
					"save": "Salvar",
					"undo": "Desfazer",
					"cancel": "Cancelar",
					"landscape": "Paisagem",
					"portrait": "Retrato",
					"yes": "Sim",
					"select_plan": "Selecione um plano",
					"no": "Não",
					"pay": "Pagar",
					"receive": "Receber"
				}
			},
			"create_branch": {
				"labels": {
					"fiscal": "NF-e e NFC-e",
					"finish": "Finalizar",
					"next": "Próximo",
					"previous": "Anterior"
				}
			},
			"branches": {
				"label": "Filial",
				"plural_label": "Filiais",
				"all_label": "Todas as filiais",
				"add_label": "Adicionar nova filial",
				"delete_label": "Remover esta filial",
				"form": {
					"name": "Nome da filial.",
					"phone_number": "Número de telefone",
					"fancy_name": "Nome fantasia",
					"cnpj": "Cadastro Nacional da Pessoa Juridica (CNPJ)",
					"state_registry": "Inscrição Estadual",
					"main_cnae": "Classificação Nacional de Atividades Econômicas (CNAE)",
					"crt": "Codigo de Regime Tributario",
					"main_company": "Filial é a empresa principal?",
					"address": "Dados de endereço da filial",
					"street": "Rua da filial",
					"street_number": "Número do estabelecimento",
					"complement": "Complemento",
					"district": "Bairro",
					"postal_code": "CEP",
					"city_location": ""
				}
			},
			"pos": {
				"labels": {
					"title": "Ponto de Vendas",
					"discount": {
						"title": "Aplicar desconto",
						"money": "Dinheiro",
						"percent": "Porcentagem",
						"tip_money": "* O desconto em $ não pode ultrapassar o valor da venda",
						"tip_percent": "* O desconto em % não pode ultrapassar de 100"
					},
					"client": {
						"title": "Selecione/cadastre um cliente",
						"name": "Nome",
						"email": "Email",
						"phone": "Telefone",
						"basic_info": "Informações Básicas"
					}
				},
				"buttons": {
					"set_discount": "Desconto",
					"select_client": "Selecionar cliente",
					"new_client": "Cadastrar cliente",
					"save": "Salvar",
					"add": "Adicionar",
					"remove": "Remover",
					"back": "Voltar",
					"cancel": "Cancelar",
					"confirm": "Confirmar"
				}
			},
			"invoices": {
				"label": "Fatura",
				"plural_label": "Faturas"
			},
			"payments": {
				"label": "Pagamento",
				"payment": {
					"label": "Pagamentos",
					"plural_label": "Métodos de pagamentos"
				}
			}
		}
	},
	"en-US": {
		"currency_symbol": "$",
		"name": "Easy Gestor WEB",
		"nav": {
			"welcome": "Welcome to Easy Gestor Web",
			"search_placeholder": "Search for something...",
			"log_out": "Log out"
		},
		"common": {
			"errors": {
				"email": {
					"email_already_exists": "User with this Email already exists."
				},
				"phone_number": {
					"max_length": "Ensure this field has no more than 11 characters."
				},
				"plan": {
					"no_plan": "Select a plan to access this action."
				}
			},
			"informations": "Informations",
			"address": "Address",
			"data": {
				"yearly": "Yearly"
			},
			"action": {
				"label": "Action",
				"plural": "Actions",
				"add": "New",
				"delete": "Remove",
				"edit": "Edit",
				"all": "All",
				"list": "List",
				"save": "Save",
				"cancel": "Cancel"
			},
			"person": {
				"basic_info": "Basic Information",
				"name": "Name",
				"email": "E-mail",
				"phone_number": "Phone Number",
				"person_type": "Type",
				"password": "Password"
			}
		},
		"pages": {
			"dashboard": {
				"top_header": {
					"search": "Do your research ...",
					"exit_button": "Exit"
				},
				"graphs": {
					"sales": {
						"title": "Sales chart",
						"total_sales_today": "Total billed today"
					}
				}
			},
			"sales": {
				"label": "Sale",
				"plural_label": "Sales"
			},
			"login": {
				"welcome": "Welcome to",
				"description": "EasyGestor online is a Management System, focused on small businessess, no installations, all managed cloud technology. To maintain EasyGestor, some specific solutions such as issuing Brasilian Invoice, Inventory Control, Sales Report, etc., will be charged through a monthly subscription according to your need. Don't worry, no payments will be made without your prior authorization.",
				"login_form": {
					"label": "Sign-in",
					"erros": {
						"email_empty": "Email cannot be empty"
					},
					"inputs_placeholders": {
						"email": "Enter your email",
						"password": "Type your password"
					},
					"buttons_label": {
						"to_sing": "Login",
						"to_sigup": "Register here",
						"to_reset_password": "Forgot password?"
					}
				}
			},
			"register": {
				"welcome": "Register to",
				"register_form": {
					"label": "Create Account",
					"have_account": "Already have an account?",
					"enter_your_name": "Whats your name?",
					"enter_your_email": "Type your email",
					"enter_your_phone": "Enter your phone number",
					"enter_your_address": "Postal codePostal code",
					"enter_your_password": "Choose Your password",
					"confirm_passwd": "Confirm your password",
					"read_terms": "I read and agree with",
					"terms": "the terms and conditions of use"
				}
			},
			"products": {
				"label": "Products",
				"singular": "Product",
				"all_label": "All Products",
				"categories": {
					"label": "Categorie",
					"plural_label": "Categories",
					"all_label": "All Categories",
					"add_label": "Add a new category",
					"edit_label": "Edit this category"
				},
				"units": {
					"label": "Unit",
					"plural_label": "Units",
					"all_label": "All Units",
					"add_label": "Add new unit",
					"edit_label": "Edit this unit"
				},
				"stock": {
					"label": "Stock"
				},
				"suppliers": {
					"label": "Suppliers",
					"plural_label": "Suppliers",
					"all_label": "All Suppliers",
					"add_label": "Add Supplier",
					"edit_label": "Edit Supplier"
				},
				"clients": {
					"label": "Clients",
					"plural_label": "Clients",
					"singular_label": "Client",
					"add_label": "Add Client",
					"all_label": "All Clients",
					"edit_label": "Edit Client"
				}
			},
			"statistics": {
				"label": "Statistics"
			},
			"reports": {
				"label": "Reports"
			},
			"salesperson": {
				"singular_label": "Salesperson",
				"plural_label": "Salespeople",
				"add_label": "Add Salesperson"
			},
			"financial": {
				"label": "Finances"
			},
			"stock": {
				"labels": {
					"menu_title": "Stock",
					"page_title": "Stock's Info",
					"total_in_stock": "Total in Stock",
					"negative_stock": "Negative Stock",
					"products_in_stock": "Products in Stock",
					"products_with_negative": "Products with negative Stock",
					"product": "Product",
					"quant_in_stock": "Quantity"
				}
			},
			"product_stock_history": {
				"label": "Stock History"
			},
			"settings": {
				"list": [
					{
						"name": "User"
					},
					{
						"name": "Branch"
					},
					{
						"name": "Plan and Invoices"
					}
				],
				"labels": {
					"title": "Settings",
					"user": {
						"name": "Name",
						"current_name": "Current user's name",
						"phone": "Phone Number",
						"current_phone": "Current user's phone number",
						"email": "Email",
						"current_email": "Current user's email"
					},
					"branch": {
						"name": "Name",
						"current_name": "Current branch's name",
						"fancy_name": "Fancy name",
						"current_fancy_name": "Current branch's fancy name",
						"phone": "Phone Number",
						"current_phone": "Current branch's phone number",
						"email": "Email",
						"current_email": "Current branch's email",
						"thank_message": "thank you message",
						"thank_message_info": "thank you message to client",
						"note_orientation": "Note Orientation",
						"note_orientation_info": "Note printing orientation",
						"paper_printing": "Priting Paper",
						"paper_printing_info": "Printing paper model",
						"automatic_printing": "Automatic printing",
						"automatic_printing_info": "Do you want to open the print dialog automatically?"
					},
					"invoice": {
						"plan": "Plan",
						"invoices": "Invoices",
						"invoice": "Invoice",
						"situation": "Situation",
						"actions": "Actions",
						"pending": "Pending",
						"paid": "Paid"
					}
				},
				"buttons": {
					"save": "Save",
					"undo": "Undo",
					"cancel": "Cancel",
					"landscape": "Landscape",
					"portrait": "Portrait",
					"yes": "Yes",
					"select_plan": "Select a plan",
					"no": "No",
					"pay": "Pay",
					"receive": "Receive"
				}
			},
			"create_branch": {
				"labels": {
					"fiscal": "Brazilian Invoice",
					"finish": "Finish",
					"next": "Next",
					"previous": "Previous"
				}
			},
			"branches": {
				"label": "Branch",
				"plural_label": "Branches",
				"all_label": "All Branches",
				"add_label": "Create new branch",
				"delete_label": "Remover esta filial",
				"form": {
					"name": "Branche name",
					"phone_number": "Phone number",
					"fancy_name": "Fancy name",
					"cnpj": "(CNPJ)",
					"state_registry": "State Registry",
					"main_cnae": "(CNAE)",
					"crt": "CRT",
					"main_company": "Main company",
					"address": "Address",
					"street": "Street",
					"street_number": "Street number",
					"complement": "Complement",
					"district": "District",
					"postal_code": "Postal Code",
					"city_location": ""
				}
			},
			"pos": {
				"labels": {
					"title": "Point of sales",
					"discount": {
						"title": "Apply discount",
						"money": "Money",
						"percent": "Percentage",
						"tip_money": "* The discount in $ cannot exceed the sale's value",
						"tip_percent": "* The discount in % cannot exceed 100%"
					},
					"client": {
						"title": "Select/register a client",
						"name": "Name",
						"email": "Email",
						"phone": "Phone Number",
						"basic_info": "Basic Information"
					}
				},
				"buttons": {
					"set_discount": "Discount",
					"select_client": "Select a Client",
					"new_client": "Register Client",
					"save": "Save",
					"add": "Add",
					"remove": "Remove",
					"back": "Back",
					"cancel": "Cancel",
					"confirm": "Confirm"
				}
			},
			"invoices": {
				"label": "Invoice",
				"plural_label": "Invoices"
			},
			"payments": {
				"label": "Payment",
				"payment": {
					"label": "Payments",
					"plural_label": "Payments Methods"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/sources/languages/languages.json
// module id = 1538
// module chunks = 0